import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Text } from '~components/Typography';
import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';
import { ButtonSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary';
import { MqTablet } from '~theme/media';

export const Spacer = styled.div`
	${MqTablet} {
		flex-grow: 1;
	}
`;
export const modal = css`
	overflow: auto;
	flex-direction: column;
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	z-index: 1;
	top: 2rem;
	right: 2rem;
`;

export const BenefitsContent = styled.div`
	position: relative;
	display: flex;
	width: 100%;
	height: 100%;
	flex-direction: column;
	padding: 2.4rem;
	background: var(--color-grey-10-solid);
	gap: var(--gap-x6);

	${MqTablet} {
		width: 44rem;
		height: fit-content;
		border-radius: var(--radius-l);
		margin-right: auto;
		margin-left: auto;
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const HighlightedTitle = styled(Text)`
	align-items: center;
	padding: 0.2rem 1rem;
	border-radius: var(--radius-xs) var(--radius-xs) 0 0;
	background: var(--color-rose-58-solid);
	color: var(--color-grey-6-solid);
`;

export const BenefitsWrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	border-radius: var(--radius-s);
	background-color: var(--color-white-xxs);
	gap: var(--gap-x3);
	padding-block: 2.4rem;
	padding-inline: 1.6rem;

	${MqTablet} {
		padding-inline: 3.2rem;
	}
`;

export const BenefitsList = styled.div`
	display: grid;
	gap: var(--gap-m);
	grid-template-columns: auto 1fr auto;
`;

export const FirstColumn = styled(Text)`
	padding-right: 0.4rem;
`;

export const ThirdColumn = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: var(--gap-m);
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: var(--color-white-xs);
`;

export const TotalWrapper = styled.div`
	display: flex;
	width: 100%;
	align-items: center;

	gap: var(--gap-m);
	& > *:first-child {
		flex-grow: 1;
	}
`;

export const ActionsWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: 22rem;
	flex-direction: column;
	margin: 0 auto;
	gap: var(--gap-x4);

	${MqTablet} {
		max-width: none;
		flex-direction: row;
	}

	& > * {
		flex-grow: 1;

		${MqTablet} {
			flex-basis: 1px;
		}
	}
`;

export const WarnButton = styled(ButtonSecondary)`
	color: var(--color-error);
`;
